// theme/index.js
import { extendTheme } from "@chakra-ui/react";
import { colors } from "./colors";

export const theme = extendTheme({ colors });
